import { signOut } from "aws-amplify/auth";
import {
  clearPatientSession,
  patientLoginPath,
  revokePatientSession,
} from "../features/patient-auth";
import { type HttpBehavior, http } from "./http";

const buildRevokeCookieErrorContext = (
  error: unknown,
): Record<string, unknown> => {
  const context: Record<string, unknown> = {
    endpoint: "/media-access/cookies",
    method: "DELETE",
  };

  if (typeof error === "object" && error !== null) {
    const e = error as Record<string, unknown>;
    if (typeof e.status === "number") context.status = e.status;
    if (typeof e.title === "string") context.title = e.title;
    if (typeof e.detail === "string") context.detail = e.detail;
    if (typeof e.code === "string") context.code = e.code;
  } else {
    context.error = String(error);
  }

  return context;
};

async function revokeMediaAccessCookies(
  behavior?: HttpBehavior,
): Promise<void> {
  try {
    if (behavior) {
      await http("/media-access/cookies", { method: "DELETE" }, behavior);
    } else {
      await http("/media-access/cookies", { method: "DELETE" });
    }
  } catch (error) {
    // Logout should proceed even when cookie revoke fails.
    console.warn(
      "Failed to revoke media access cookies",
      buildRevokeCookieErrorContext(error),
      error,
    );
  }
}

export async function signOutWithMediaCookieRevoke(): Promise<void> {
  await revokeMediaAccessCookies();
  await signOut();
}

/**
 * 患者の SAS のログアウト（web のフラグが ON。Issue #473）。メディアの Cookie の削除、サインアウトの API、
 * セッションの削除の順に行い、ログインの画面へ移す。
 *
 * Cookie の削除は、画面の URL によらず SAS のトークンを付け（エラーの画面の PC のヘッダーからも呼ぶため）、
 * アクセストークンが切れていれば取り替えて送り直すが、ログインの画面へは移さずに呼ぶ（セッションが切れていても、
 * notice=expired への移動とぶつからずに「ログアウトしました。」になる）。取り替えにリフレッシュトークンを使うので、
 * サーバーの失効より前に行う。
 */
export async function signOutPatientWithMediaCookieRevoke(): Promise<void> {
  await revokeMediaAccessCookies({
    credential: "patient",
    redirectOnUnauthorized: false,
  });
  await revokePatientSession();
  clearPatientSession();
  window.location.assign(patientLoginPath("signed-out"));
}
